const API = {
  // path: window.location.protocol + "//" + window.location.host + '/api/'
  // path: `https://wkcda-10a68.firebaseapp.com/api/`
  // path: `http://localhost:8081/api/`
  //path: (location) => `https://support.westkowloon.hk/api/`,
  path: (location) => `https://support.westkowloon.hk/api/`,
  //   path: (location) => `http://128.199.67.222/api/`
  // path: (location) => location.protocol+'//'+location.hostname+(location.port ? ':'+location.port+'/' : '/'),
  redirect_uri: `https://support.westkowloon.hk/donation/ciam/oauth_callback`,
  auth_url: `https://my.westkowloon.hk/s/CustomerPortal/services/oauth2/authorize`,

  token_url:
    "https://my.westkowloon.hk/s/CustomerPortal/services/oauth2/token",


  client_id:
    "3MVG9Nvmjd9lcjRlEznw.Q6qDKZV_R4U9vssPM3FfG4c9w8UBHYQiHRrmHbHjgVpZnfBjj2GLHs8vbcVWwnu0",
  o_client_id:
    "3MVG9Nvmjd9lcjRlEznw.Q6qDKRhuOzpfbDVjQGcLBAbMxeys_xNkxDxnlNIJ0Z8oiN3Wv0DFXcep.FEdizTK",
  client_secret:
    "C3FD9426CC6ADFC909BDD9442835C6603D94134FB322D3B0705890369FEF1E37",
  o_client_secret:
    "338035742C63F23C73CB00549BD524C39EE8D223C85D4306C045695C4E95591A",
};

export default API;
